<script lang="ts">
export interface ProseH3Props {
  id?: string
  class?: any
}

export interface ProseH3Slots {
  default: (props?: object) => unknown
}
</script>

<script setup lang="ts">
const props = defineProps<ProseH3Props>()
defineSlots<ProseH3Slots>()
</script>

<template>
  <h3
    :id
    class="my-1 text-base font-semibold"
    :class="props.class"
  >
    <a
      v-if="id"
      :href="`#${id}`"
    >
      <slot />
    </a>
    <slot v-else />
  </h3>
</template>
